import { render, staticRenderFns } from "./CompanyScreen.vue?vue&type=template&id=01295ddc&scoped=true"
import script from "./CompanyScreen.vue?vue&type=script&lang=js"
export * from "./CompanyScreen.vue?vue&type=script&lang=js"
import style0 from "./CompanyScreen.vue?vue&type=style&index=0&id=01295ddc&prod&lang=scss&scoped=true"
import style1 from "./CompanyScreen.vue?vue&type=style&index=1&id=01295ddc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01295ddc",
  null
  
)

export default component.exports